import { get, post, put } from 'helpers/api';

const rootPath = '/backoffice/contacts';

export async function searchContacts({ query, type }, callback) {
  const results = await get(`${rootPath}/search`, { params: { query, type } });
  callback(results);
}

export async function saveContact(contact, forRecord, {
  allowSavingPrivateContacts = false,
  apiHelpers = {},
  params = {},
  saveAsRoot = null,
} = {}) {
  const body = {
    ...contact,
    additionalEmailsAttributes: contact.additionalEmails,
    addressesAttributes: contact.addresses,
    phoneNumbersAttributes: contact.phoneNumbers,
  };

  if (!allowSavingPrivateContacts && contact.private) {
    body.saveAsCanonical = true;
  } else if (saveAsRoot != null) {
    body.saveAsSnapshot = !saveAsRoot;
  }

  body.businessRecordsAttributes = [];
  for (const { business, ...attributes } of contact.businessRecords) {
    if (business?.id) {
      body.businessRecordsAttributes.push({
        ...attributes,
        businessId: business.id,
      });
    } else if (business?.crmContactId && business?.crmContactType) {
      body.businessRecordsAttributes.push({
        ...attributes,
        crmContactId: business.crmContactId,
        crmContactType: business.crmContactType,
      });
    }
  }

  if (contact.crmTags) {
    body.crmTagsAttributes = contact.crmTags;
  }

  delete body.additionalEmails;
  delete body.addresses;
  delete body.businessRecords;
  delete body.phoneNumbers;
  delete body.crmTags;

  body.forRecord = forRecord;

  let method, path;
  if (body.id) {
    method = apiHelpers.put || put;
    path = `${rootPath}/${body.id}`;
  } else {
    method = apiHelpers.post || post;
    path = rootPath;
  }

  if (params && Object.keys(params).length) {
    path = `${path}?${new URLSearchParams(params)}`;
  }

  return await method(path, body);
}
